// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"197":"polyfill-set","947":"polyfill-requestAnimationFrame","984":"polyfill-startsWith"}[chunkId] + "." + {"197":"8095e6ba","947":"357e46ce","984":"2e0ceb15"}[chunkId] + ".chunk.js";
};